import React from 'react';
import TublyLogo from './TublyLogo';
import { CHROME_STORE_URL } from '../constants';

const Header: React.FC = () => (
  <header
    className="fixed left-0 right-0 bg-white/80 backdrop-blur-sm z-50 shadow-sm"
    style={{ top: 'var(--disclaimer-banner-height, 0px)' }}
  >
    <div className="container mx-auto px-6 py-3 flex justify-between items-center">
      <a href="/" className="flex items-center gap-3">
        <TublyLogo className="w-8 h-auto" />
        <h1 className="text-xl font-bold text-gray-900">tubly</h1>
      </a>
      <nav className="hidden md:flex items-center gap-6 text-sm text-gray-700">
        <a href="/" className="hover:text-gray-900">Home</a>
        <a href="/privacy" className="hover:text-gray-900">Privacy</a>
        <a href="/terms" className="hover:text-gray-900">Terms</a>
        <a href="/how-it-works" className="hover:text-gray-900">How it works</a>
      </nav>
      <a href={CHROME_STORE_URL} className="bg-red-500 text-white font-semibold px-4 py-2 rounded-lg hover:bg-red-600 transition-colors text-sm shadow">
        Add to Chrome
      </a>
    </div>
  </header>
);

export default Header;
